/**
 * Route paths for bilingual (EN/ES) pages.
 * Use getPaths(lang) for paths based on current language.
 */

export const EN_HOME_PATH = "/";
export const EN_THANKYOU_PATH = "/thank-you";
export const EN_CLIENTS_PATH = "/how to get clients for your commercial cleaning business";
export const EN_PROMOTE_PATH = "/how to promote your commercial cleaning business";

export const ES_HOME_PATH = "/inicio";
export const ES_THANKYOU_PATH = "/gracias";
export const ES_CLIENTS_PATH = "/conseguir-clientes-para-tu-negocio-limpieza";
export const ES_PROMOTE_PATH = "/promocionar-tu-negocio-limpieza-comercial";

const PATH_MAP = {
  en: { home: EN_HOME_PATH, thankyou: EN_THANKYOU_PATH, clients: EN_CLIENTS_PATH, promote: EN_PROMOTE_PATH },
  es: { home: ES_HOME_PATH, thankyou: ES_THANKYOU_PATH, clients: ES_CLIENTS_PATH, promote: ES_PROMOTE_PATH },
};

/**
 * @param {"en"|"es"} lang
 * @returns {{ homePath: string, thankyouPath: string, clientsPath: string, promotePath: string }}
 */
export function getPaths(lang) {
  const key = lang === "es" ? "es" : "en";
  const { home, thankyou, clients, promote } = PATH_MAP[key];
  return { homePath: home, thankyouPath: thankyou, clientsPath: clients, promotePath: promote };
}

/**
 * Detect site language from the current URL path.
 * @param {string} pathname
 * @returns {"en"|"es"}
 */
export function getLangFromPath(pathname) {
  const path = pathname.replace(/\/$/, "") || "/";
  if (path === ES_HOME_PATH || path === ES_THANKYOU_PATH || path === ES_CLIENTS_PATH || path === ES_PROMOTE_PATH) return "es";
  if (path === EN_HOME_PATH || path === EN_THANKYOU_PATH || path === EN_CLIENTS_PATH || path === EN_PROMOTE_PATH) return "en";
  // Shared/unknown pages (checkout, etc.): use saved language preference
  if (typeof localStorage !== "undefined" && localStorage.getItem("site_lang") === "es") {
    return "es";
  }
  return "en";
}

/**
 * Map current pathname to the same page in the other language (for language switch).
 * @param {string} pathname
 * @param {"en"|"es"} targetLang
 * @returns {string|null} path for target language, or null if not a bilingual page
 */
export function getPathForLanguage(pathname, targetLang) {
  const path = pathname.replace(/\/$/, "") || "/";

  if (path === EN_HOME_PATH || path === ES_HOME_PATH) {
    return targetLang === "es" ? ES_HOME_PATH : EN_HOME_PATH;
  }

  if (path === EN_THANKYOU_PATH || path === ES_THANKYOU_PATH) {
    return targetLang === "es" ? ES_THANKYOU_PATH : EN_THANKYOU_PATH;
  }

  if (path === EN_CLIENTS_PATH || path === ES_CLIENTS_PATH) {
    return targetLang === "es" ? ES_CLIENTS_PATH : EN_CLIENTS_PATH;
  }

  if (path === EN_PROMOTE_PATH || path === ES_PROMOTE_PATH) {
    return targetLang === "es" ? ES_PROMOTE_PATH : EN_PROMOTE_PATH;
  }

  return null;
}
